import { Team } from "../../../types/form";
import { FieldRegistryConfig } from "../../types";
import { TeamFieldControl } from "./TeamFieldControl/TeamFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export type TeamFormValue = Team & {
  team: Team;
};

export type TeamFieldValue = string[];

/**
 * Stores the team object both at top level (for ID access) and nested in the 'team' key
 * (for name-based comparisons in conditional visibility logic).
 * The nested 'team' field is used by formValueFormatters.ts to extract names for
 * "contains"/"not_contains" comparisons.
 *
 * When submitting the form, we send only the IDs.
 */
export const teamFieldConfig: FieldRegistryConfig<TeamFormValue[], TeamFieldValue> = {
  icon: "team",
  control: TeamFieldControl,
  convertFormValueToApi: (value) => value.map((v) => v.id),
  prefill: ({ value, field, members }) => {
    const teamIds = value.split(",");

    const selectedTeams = members?.filter(
      (team) => teamIds.includes(team.id.toString()) || teamIds.includes(team.name)
    );

    if (!selectedTeams?.length || !members?.length) return null;

    if (field.params.entries_allowed === "multiple") {
      return selectedTeams;
    }

    return [selectedTeams[0]];
  },
  toReviewString: defaultToReviewString,
};
